import { storeInformationQueries } from "$/hooks/use-store-information"
import { StoreFeature, hasStoreFeature } from "@repo/common"
import { QueryClient } from "@tanstack/react-query"
import { redirect } from "@tanstack/react-router"

export const requireStoreFeature = async (
  queryClient: QueryClient,
  feature: StoreFeature,
) => {
  const storeInfo = await queryClient.ensureQueryData(
    storeInformationQueries.detail(queryClient),
  )
  const currentStore = storeInfo.stores.find(
    (store) => store.id === storeInfo.storeId,
  )
  if (!hasStoreFeature(currentStore?.tier ?? null, feature)) {
    throw redirect({ to: "/", replace: true })
  }
}
